// extracted by mini-css-extract-plugin
export default {"button":"kgt-N___OverflowMenuItem-module__button"};